import { intercomTrackEvent } from '../../../../../analytics/intercomService';
import { sendAmplitudeEvent } from '../../../../../analytics/amplitudeService';

export enum ImageModalFlipDirection {
    HORIZONTAL = 'Horizontal',
    VERTICAL = 'Vertical',
}

export const trackImageModalFlip = (direction: ImageModalFlipDirection): void => {
    sendAmplitudeEvent({
        eventType: 'Image flipped',
        eventProperties: { direction },
    });

    intercomTrackEvent('flipped-image');
};
